import { useDispatch, useSelector } from 'react-redux';

import {
  resetAreQuestionsUpdating,
  UpdateQuestionsPayload,
  updateQuestions,
} from '../reducers/graph';
import { useInitialQuestions } from './useInitialQuestions';

import { useQuestions } from './useQuestions';
import { useCallback } from 'react';
import { RootState } from '../types/graph';
import { useFormulas } from './useFormulas';
import { initialQuestionIds } from '@aldebaran/common/constants/kb';

export const useSynchronizeKB = () => {
  const dispatch = useDispatch();

  const queue = useSelector((state: RootState) => state.questionnaire.queue);
  const queueEmpty =
    queue.filter((q) => !Object.values(initialQuestionIds).includes(q))
      .length <= 1;

  useInitialQuestions(queueEmpty);
  useFormulas(queueEmpty);

  const onComplete = useCallback(
    (payload: UpdateQuestionsPayload) => {
      dispatch(updateQuestions(payload));
    },
    [dispatch],
  );

  const onError = useCallback(() => {
    dispatch(resetAreQuestionsUpdating());
  }, [dispatch]);

  return useQuestions(queue, onComplete, onError);
};
